class Accordion {
  constructor(classname) {
    this.classname = classname;
    this.accordions = document.querySelectorAll(this.classname);
    this.initialize();
  }

  initialize() {
    this.accordions.forEach(targetAccordion => {
      targetAccordion.addEventListener('click', () => {
        // Close all the details that are not targetDetail.
        this.accordions.forEach(accordion => {
          if (accordion !== targetAccordion) {
            accordion.removeAttribute('open');
          }
        });
      });
    });
  }
}

export default Accordion;
